import apiClient from './client';
import { User, UserCreateRequest, UserUpdateRequest, ChangePasswordRequest } from '@/types/api';

export const getUsers = async (): Promise<User[]> => {
  const response = await apiClient.get<User[]>('/users');
  return response.data;
};

export const getUser = async (id: number): Promise<User> => {
  const response = await apiClient.get<User>(`/users/${id}`);
  return response.data;
};

export const createUser = async (data: UserCreateRequest): Promise<User> => {
  const response = await apiClient.post<User>('/users', data);
  return response.data;
};

export const updateUser = async (id: number, data: UserUpdateRequest): Promise<User> => {
  const response = await apiClient.put<User>(`/users/${id}`, data);
  return response.data;
};

export const deleteUser = async (id: number): Promise<void> => {
  await apiClient.delete(`/users/${id}`);
};

export const changePassword = async (id: number, data: ChangePasswordRequest): Promise<void> => {
  await apiClient.put(`/users/${id}/password`, data);
};
